/**
 * Kaynak (Order.source) → rozet harfi eşlemesi.
 *
 * Siparişler ekranında HAYAT_PANEL'den gelen mi yoksa ABANT_PANEL'den gelen mi olduğunu
 * kullanıcı tek harfle görür (§3.6, kullanıcı kararı 29.09.2026). Kaynakların harfleri sabittir;
 * `Brand.code`'dan bağımsız tutulur çünkü eşleme panelin sunum katmanına aittir, marka sözlüğü
 * devrilirse burası etkilenmez.
 *
 *   HAYAT_PANEL  → 'H'  (Hayat mavisi)
 *   ABANT_PANEL  → 'A'  (yeşil)
 *   GETIR_SU     → 'G'  (nötr)
 *   TRENDYOL     → 'T'  (nötr)
 *   YEMEKSEPETI  → 'Y'  (nötr)
 *   MANUAL       → null (telefon/elle; rozet çizilmez)
 *
 * Tanınmayan kaynak `null` döner. Yeni kanal eklenirse buraya eklenir; sessizce düşmesine
 * güvenilmez — çağıran taraf `null` ile "rozet yok" kararını açıkça verir.
 */

export type ScraperLetter = 'H' | 'A' | 'G' | 'T' | 'Y';

const SOURCE_LETTER: Record<string, ScraperLetter | null> = {
  HAYAT_PANEL: 'H',
  ABANT_PANEL: 'A',
  GETIR_SU: 'G',
  TRENDYOL: 'T',
  YEMEKSEPETI: 'Y',
  MANUAL: null,
};

export function sourceLetter(source: string): ScraperLetter | null {
  return SOURCE_LETTER[source] ?? null;
}
